import React from "react";
import { RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Unhandled render error:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 px-5" data-testid="error-boundary-screen">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-extrabold text-[#0F1B2E] mb-2">Something went wrong</h1>
            <p className="text-sm text-slate-600 mb-6">
              Sorry — that didn't work. Your progress is saved. Reload the page to carry on where you left off.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 rounded-full bg-[#E63B2E] hover:bg-[#c92f24] text-white font-bold px-6 py-3 text-sm"
              data-testid="error-boundary-reload"
            >
              <RefreshCw className="w-4 h-4" /> Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
